import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { QUERY_PARAM_KEY, QUERY_PARAM_VALUE } from '_constants/queryParams';

const QUERY_PARAM_VALUE_ARRAY = [QUERY_PARAM_VALUE.personal, QUERY_PARAM_VALUE.business];

export const useUploadDocumentsQueryParam = () => {
  const [params, setParams] = useSearchParams();
  const currentParam = params.get(QUERY_PARAM_KEY.uploadDocumentsTab);

  const setCurrentParam = (value) => {
    params.delete(QUERY_PARAM_KEY.uploadDocumentsTab);
    params.append(QUERY_PARAM_KEY.uploadDocumentsTab, value);
    setParams(params);
  };

  useEffect(() => {
    if (!QUERY_PARAM_VALUE_ARRAY.includes(currentParam)) {
      params.delete(QUERY_PARAM_KEY.uploadDocumentsTab);
      params.append(QUERY_PARAM_KEY.uploadDocumentsTab, QUERY_PARAM_VALUE.personal);
      setParams(params);
    }
  }, [currentParam, params, setParams]);

  return [currentParam, setCurrentParam];
};
